// extracted by mini-css-extract-plugin
export default {"multiple_choice":"MultipleChoice_multiple_choice__QABsv","unpressed":"MultipleChoice_unpressed__iUUCR","pressed":"MultipleChoice_pressed__0LPnh"};